import React, { useEffect, useState } from "react";
import Gallery from "./Gallery";
import LatestEvents from "./LatestEvents";
import LatestFeaturedEvent from "./LatestFeaturedEvent";
import Mission_Vission from "./Mission_Vission";
import Pricing from "./Pricing";
import headerImg from "../../assets/images/headerImg.svg";
import Achievement from "../Achievement";
import video from '../../assets/video.mp4'
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../Firebase/config";

export default function Home() {

  const [newsletter_url, setNewsletter_url] = useState('')

  useEffect(() => {
    fetchNewsletter()
  }, [])

  const fetchNewsletter = async () =>{
    const docRef = doc(db, "config", "newsletter");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      setNewsletter_url(docSnap.data().link)
    }
  }

  return (
    <div className="w-full leading-normal relative -mt-24 tracking-normal text-white gradient  bg-blue-700">
      <div class="relative pt-32 sm:pt-40 flex w-full">
        <video autoplay={'on'} muted loop id="myVideo" className='absolute inset-0 w-full object-fill min-h-full'>
          <source src={video} type="video/mp4" />
        </video>
        <div class="w-full max-w-7xl 2xl:max-w-7xl  px-3 lg:px-10 mx-auto flex flex-wrap flex-col md:flex-row items-center">
          <div class="relative flex flex-col w-full md:w-1/2 justify-center items-start text-center md:text-left">
            <h1 class="my-4 text-5xl font-bold leading-tight">
              Welcome to IEEE SB MITS
            </h1>
            <p class="leading-normal sm:text-2xl lg:mt-8 mb-8">
              Platform for the young minds to explore and experiment
              technological advancements with professional competencies
              following ethical standards
            </p>
            <p class="uppercase tracking-loose w-full">You want to Join Us?</p>

            <a
              href="#subscriptions"
              class="mx-auto lg:mx-0 z-10 hover:underline bg-white text-gray-800 font-bold rounded-full my-6 lg:mb-10 py-4 px-8 shadow-lg"
            >
              Subscribe
            </a>

            <p class="uppercase tracking-loose w-full">Read our latest newsletter here</p>

            <a
            target="_blank"
            rel="noopener noreferrer"
            href={newsletter_url}
            class="mx-auto lg:mx-0 z-10 hover:underline bg-white text-gray-800 font-bold rounded-full my-6 lg:mb-10 py-4 px-8 shadow-lg"
            >
              Newsletter
            </a>

          </div>
          <div class="w-full md:w-1/2 my-auto text-center">
            <img
              class="ml-auto object-contain px-10 md:px-0 lg:px-10  z-50"
              src={headerImg}
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="relative -mt-12 lg:-mt-24">
        <svg
          viewBox="0 0 1428 174"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g
              transform="translate(-2.000000, 44.000000)"
              fill="#FFFFFF"
              fill-rule="nonzero"
            >
              <path
                d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                opacity="0.100000001"
              ></path>
              <path
                d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                opacity="0.100000001"
              ></path>
              <path
                d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                id="Path-4"
                opacity="0.200000003"
              ></path>
            </g>
            <g
              transform="translate(-4.000000, 76.000000)"
              fill="#FFFFFF"
              fill-rule="nonzero"
            >
              <path d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z"></path>
            </g>
          </g>
        </svg>
      </div>
      <LatestFeaturedEvent />
      <LatestEvents />
      <Mission_Vission />
      <Gallery />
      {/* <Achievement sub={true} /> */}
      <div id="subscriptions">
        <Pricing />
      </div>
    </div>
  );
}
